export default __webpack_public_path__ + "static/media/thumbnail-3.cb0e2ff1.png";